import { Helmet } from "react-helmet";
import BrandLogo from "@/components/BrandLogo";
import Container from "@/components/Container";
import Page from "@/components/Page";
import Button from "@/components/Button";
import { BrandChevron } from "@/components/Step";
import styles from "@/components/Step/Step.module.scss";
import useDevice from "@/hooks/useDevice";

export default function FlowSelectorPage() {
  const device = useDevice();

  return (
    <>
      <Helmet
        title="Blodtrycksdoktorn"
        style={[
          {
            cssText: `
              body {
                background: var(--questionnaire-bg);
              }
            `,
          },
        ]}
      />
      <Container>
        <BrandLogo />

        <Page justifyContent="flex-end">
          <h1>Bra! Låt oss börja.</h1>

          <p>Vad vill du ha hjälp med?</p>

          <div className={styles.optionWrapper}>
            <Button
              as="a"
              to="/"
              variant="secondary"
              fullWidth={device.isMobileOrTablet}
              iconRight={<BrandChevron />}
            >
              Hjälp med vikten
            </Button>

            <Button
              as="a"
              to="/hypertoni"
              variant="secondary"
              fullWidth={device.isMobileOrTablet}
              iconRight={<BrandChevron />}
            >
              Hjälp med blodtrycket
            </Button>
          </div>
        </Page>
      </Container>
    </>
  );
}
